<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <span>{{userAvator}}</span>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <template #list>
      <DropdownMenu>
            <DropdownItem name="changePwd">修改密码</DropdownItem>
            <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
      </template>
    </Dropdown>
    <template>
    <Modal v-model="changeModal" title="修改密码">
      <Form :model="formData"  ref="form" :label-width="130" :rules="validateRules">
        <FormItem label="原密码" prop="originalPwd">
          <Input v-model="formData.originalPwd" type="password" placeholder="原密码"/>
        </FormItem>
        <FormItem label="新密码" prop="newPwd">
          <Input v-model="formData.newPwd" type="password" placeholder="至少包含一个数字,一个字母,长度至少8位"/>
        </FormItem>
        <FormItem label="确认密码" prop="pwdCheck">
          <Input v-model="formData.pwdCheck" type="password" placeholder="至少包含一个数字,一个字母,长度至少8位"/>
        </FormItem>
      </Form>
      <template #footer>
        <div style="text-align: center;">
            <Button @click="reset">重置</Button>
            <Button type="primary" @click="saveChange()">确认</Button>
        </div>
      </template>
    </Modal>
    </template>
  </div>
</template>
<script>
import './user.less'
import { mapActions } from 'vuex'
export default {
  name: 'User',
  props: {
    userAvator: {
      type: String,
      default: ''
    }
  },
  data () {
    const pwdCheckValidate = (rule, value, callback) => {
      let reg = /^\S*(?=\S{8,})(?=\S*\d)(?=\S*[A-Za-z])\S*$/
      if (this.formData.newPwd !== '' && value === '') {
        callback(new Error('确认密码不能为空！'))
      } else if ((!reg.test(value))) {
         callback(new Error('长度至少8位，包括数组和字母！'))
       } else if (this.formData.newPwd !== value) {
        callback(new Error('新密码和确认密码不一致！'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        originalPwd: '',
        newPwd: '',
        pwdCheck: ''
      },
      validateRules: {
        originalPwd: [
          { required: true, message: '原密码不能为空', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '新密码不能为空', trigger: 'blur' }
        ],
        pwdCheck: [
          { required: true, validator: pwdCheckValidate, trigger: 'blur' }
        ]
      },
      changeModal: false
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut',
      'handleResetPassword'
    ]),
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.handleLogOut().then(() => {
            this.$router.push({
              name: 'login'
            })
          }, error => {
              this.$Message.error(error.message)
              this.$router.push({
                  name: 'login'
                })
            })
          break
        case 'changePwd':
              this.changeModal = true
            break
      }
    },

    cancel () {
      this.changeModal = false
    },

    reset () {
      this.formData = {
        originalPwd: '',
        newPwd: '',
        pwdCheck: ''
      }
    },

    saveChange () {
        let me = this
        me.$refs.form.validate(valid => {
          if (valid) {
             me.handleResetPassword({
              newPassword: me.formData.newPwd,
              originPassword: me.formData.originalPwd
             }).then(() => {
                 me.$Message.success('操作成功！')
                  me.cancel()
              }, error => {
                  me.$Message.error(error)
                })
          } else {
            me.$Message.error('请输入！')
          }
        })
    }
  }
}
</script>
